// eslint-disable-next-line
import { UserLayout, BasicLayout, BlankLayout, PageView } from '@/layouts'
import { cfgl, dzqk, fgsdz, jtnz, linkgl, mbgl, sz, tpgl, wzgl, xxgl, yhq, yqlj } from '@/core/icons'

const RouteView = {
  name: 'RouteView',
  render: h => h('router-view')
}
// asyncRouterMap
// constantRouterMap
export const asyncRouterMap = [
  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    hidden: true,
    meta: {
      title: 'menu.home',
    },
    redirect: '/interview',
  },
  {
    path: '/interview',
    name: 'interview',
    component: BasicLayout,
    redirect: '/interview/list',
    meta: {
      title: '运营中心',
      icon: 'table',
      permission: ['table'],
    },
    children: [
      // {
      //   path: '/demo',
      //   name: 'demo',
      //   meta: {
      //     title: 'demo',
      //     icon: 'slack',
      //     permission: [ 'dashboard' ]
      //   },
      //   component: () => import('@/views/demo/index.vue')
      // },
      {
        path: '/template/list',
        name: 'template',
        meta: {
          name: 'template',
          title: '模板管理',
          icon: mbgl,
          permission: ['opt:/api/template/list'],
        },
        component: () => import('@/views/template/index.vue'),
      },
      {
        path: '/template/edit/:id?',
        name: 'templateEdit',
        hidden: true,
        meta: {
          title: '模板管理',
          permission: [],
        },
        component: () => import('@/views/template/edit.vue'),
      },
      {
        path: '/interview/list',
        name: 'interview',
        meta: {
          title: '采访管理',
          icon: cfgl,
          permission: ['opt:/api/interview/list'],
        },
        component: () => import('@/views/interview/index.vue'),
      },
      {
        path: '/interview/edit/:id?',
        name: 'interviewEdit',
        hidden: true,
        meta: {
          title: '采访详情',
          permission: [],
        },
        component: () => import('@/views/interview/edit.vue'),
      },
      {
        path: '/picture/list',
        name: 'pictures',
        meta: {
          title: '图片管理',
          icon: tpgl,
          permission: ['opt:/api/pictures/list'],
        },
        component: () => import('@/views/picture/index.vue'),
      },
      {
        path: '/picture/edit/:id?',
        name: 'pictureEdit',
        hidden: true,
        meta: {
          title: '图片详情',
          permission: [],
        },
        component: () => import('@/views/picture/edit.vue'),
      },
      {
        path: '/article',
        name: 'article',
        meta: {
          title: '文章管理',
          icon: wzgl,
          permission: [
            'opt:/api/article/list',
            'opt:/api/article-type/list-tree',
            'opt:/api/label/list',
            'opt:/api/forbidden-words/list',
            'opt:/api/article-preview/list',
            'opt:/api/topic/list',
            'opt:/api/label/auto-label-items',
            'opt:/api/article-keyword/items',
          ],
        },
        component: () => import('@/views/article/index.vue'),
        redirect: '/article/list',
        children: [
          {
            path: '/article/list',
            name: 'articleList',
            meta: {
              title: '文章列表',
              permission: ['opt:/api/article/list'],
            },
            component: () => import('@/views/article/components/Article/index'),
          },
          {
            path: '/article/classify',
            name: 'articleClassify',
            meta: {
              title: '分类管理',
              permission: ['opt:/api/article-type/list-tree'],
            },
            component: () => import('@/views/article/components/Classify/index'),
          },
          {
            path: '/article/tag',
            name: 'articleTag',
            meta: {
              title: '标签管理',
              permission: ['opt:/api/label/list'],
            },
            component: () => import('@/views/article/components/Tag/index'),
          },
          {
            path: '/article/contrabandWord',
            name: 'articleContrabandWord',
            meta: {
              title: '违禁词管理',
              permission: ['opt:/api/forbidden-words/list'],
            },
            component: () => import('@/views/article/components/index'),
          },
          {
            path: '/article/preview',
            name: 'articlePreview',
            meta: {
              title: '预览设置',
              permission: ['opt:/api/article-preview/list'],
            },
            component: () => import('@/views/article/components/preview/index'),
          },
          {
            path: '/article/special',
            name: 'articleSpecial',
            meta: {
              title: '专题管理',
              permission: ['opt:/api/topic/list'],
            },
            component: () => import('@/views/article/components/special/index'),
          },
          {
            path: '/article/autolink',
            name: 'articleAutolink',
            meta: {
              title: '自动关联',
              permission: ['opt:/api/label/auto-label-items'],
            },
            component: () => import('@/views/article/components/autolink/index'),
          },
          {
            path: '/article/keywords',
            name: 'articleKeywords',
            meta: {
              title: '关键词内链',
              permission: ['opt:/api/article-keyword/items'],
            },
            component: () => import('@/views/article/components/keywords/index'),
          },
        ],
      },
      {
        path: '/casesManage',
        name: 'case',
        hidden: false,
        meta: {
          title: '案例管理',
          icon: wzgl,
          permission: ['opt:/api/cases/list'],
        },
        component: () => import('@/views/casesManage/index.vue'),
      },
      {
        path: '/casesDetail/:id?',
        name: 'casesDetail',
        hidden: true,
        meta: {
          title: '案例详情',
          permission: [],
        },
        component: () => import('@/views/casesManage/casesDetail.vue'),
      },
      {
        path: '/relevancy/list/:id?',
        name: 'relevancyList',
        hidden: true,
        meta: {
          title: '关联列表',
          permission: [],
        },
        component: () => import('@/views/article/components/special/relevancyList'),
      },
      {
        path: '/article/edit/:id?',
        name: 'articleEdit',
        hidden: true,
        meta: {
          title: '文章详情',
          permission: [],
        },
        component: () => import('@/views/article/edit.vue'),
      },
      {
        path: '/article/template/:id?',
        name: 'articleTemplate',
        hidden: true,
        meta: {
          title: '文章详情',
          permission: [],
        },
        component: () => import('@/views/templateForm/index.vue'),
      },
      {
        path: '/article/choosetemplate',
        name: 'chooseTemplate',
        hidden: true,
        meta: {
          title: '选择模板',
          permission: [],
        },
        component: () => import('@/views/article/components/Article/components/chooseTemplate.vue'),
      },
      {
        path: '/article/edittemplate',
        name: 'editTemplate',
        hidden: true,
        meta: {
          title: '编辑模板',
          permission: [],
        },
        component: () => import('@/views/article/components/Article/components/editTemplate.vue'),
      },
      // {
      //   path: '/active',
      //   name: 'activeList',
      //   redirect: '/active/list',
      //   meta: {
      //     title: '活动抽奖管理',
      //     icon: 'slack',
      //     permission: [ 'dashboard' ]
      //   },
      //   component: RouteView,
      //   children: [
      //     {
      //       path: 'awardwin',
      //       name: 'activeList',
      //       meta: {
      //         title: '获奖列表',
      //         icon: 'slack',
      //         permission: [ 'dashboard' ]
      //       },
      //       component: () => import('@/views/active/awardWin/index.vue')
      //     },
      // {
      //   path: '/couponlist',
      //   name: 'coupon',
      //   meta: {
      //     title: '优惠券',
      //     icon: yhq,
      //     permission: ['dashboard']
      //   },
      //   component: () => import('@/views/active/coupon/index.vue')
      // },
      {
        path: '/coupon-manager',
        // name: 'couponManager',
        name: 'coupon',
        redirect: '/coupon-manager/list',
        component: RouteView,
        meta: {
          title: '优惠券管理',
          icon: yhq,
          permission: ['opt:/api/coupon/list', 'opt:/api/coupon-record/items'],
        },
        children: [
          {
            path: '/coupon-manager/list',
            name: 'couponList',
            meta: {
              title: '优惠券',
              permission: ['opt:/api/coupon/list'],
            },
            component: () => import('@/views/coupon/index.vue'),
          },
          {
            path: '/coupon-manager/coupon-edit/:id?',
            name: 'couponEdit',
            hidden: true,
            meta: {
              title: '优惠券详情',
              permission: [],
            },
            component: () => import('@/views/coupon/couponEdit.vue'),
          },
          {
            path: '/coupon-manager/coupon-detail/:id?',
            name: 'couponDetail',
            hidden: true,
            meta: {
              title: '优惠券详情',
              permission: [],
            },
            component: () => import('@/views/coupon/couponDetail.vue'),
          },
          {
            path: '/coupon-manager/receive-records',
            name: 'receiveRecords',
            meta: {
              title: '优惠券领取记录',
              permission: ['opt:/api/coupon-record/items'],
            },
            component: () => import('@/views/coupon/couponReceiveRecords.vue'),
          },
        ],
      },
      //     {
      //       path: 'totallist',
      //       name: 'totalList',
      //       meta: {
      //         title: '获奖统计',
      //         icon: 'slack',
      //         permission: [ 'dashboard' ]
      //       },
      //       component: () => import('@/views/active/total/index.vue')
      //     },
      //     {
      //       path: 'prizelist',
      //       name: 'prizeList',
      //       meta: {
      //         title: '抽奖奖品',
      //         icon: 'slack',
      //         permission: [ 'dashboard' ]
      //       },
      //       component: () => import('@/views/active/prize/index.vue')
      //     },
      //     {
      //       path: 'cashPrizelist',
      //       name: 'cashPrizeList',
      //       meta: {
      //         title: '兑换商品',
      //         icon: 'slack',
      //         permission: [ 'dashboard' ]
      //       },
      //       component: () => import('@/views/active/cashPrize/index.vue')
      //     },
      //   ]
      // },
      {
        path: '/friendshiplink',
        name: 'links',
        meta: {
          title: '友情链接',
          icon: yqlj,
          permission: ['opt:/api/links/list'],
        },
        component: () => import('@/views/friendshipLink/index.vue'),
        // component: () => import('@/views/active/coupon/index.vue')
      },
      {
        path: '/group-web',
        name: 'group',
        redirect: '/group-web/article/list',
        meta: {
          title: '集团内站',
          icon: jtnz,
          permission: [
            'opt:/api/posts/list',
            'opt:/api/posts/like-up-record',
            'opt:/api/comment/list',
            'opt:/api/posts/read-record',
          ],
        },
        component: RouteView,
        children: [
          {
            path: '/group-web/article/list',
            name: 'group.posts_list',
            meta: {
              title: '帖子管理',
              permission: ['opt:/api/posts/list'],
            },
            component: () => import('@/views/groupWeb/articleList.vue'),
          },
          {
            path: '/group-web/article/detail/:id',
            hidden: true,
            meta: {
              title: '帖子详情',
              permission: [],
            },
            component: () => import('@/views/groupWeb/artDetail.vue'),
          },
          {
            path: '/group-web/article/like',
            hidden: false,
            name: 'group.like_list',
            meta: {
              title: '点赞列表',
              permission: ['opt:/api/posts/like-up-record'],
            },
            component: () => import('@/views/groupWeb/likeList.vue'),
          },
          {
            path: '/group-web/article/comment',
            hidden: false,
            name: 'group.comment_list',
            meta: {
              title: '评论管理',
              permission: ['opt:/api/comment/list'],
            },
            component: () => import('@/views/groupWeb/comment.vue'),
          },
          {
            path: '/group-web/article/review/:id',
            hidden: true,
            name: 'review',
            meta: {
              title: '评论管理',
              permission: [],
            },
            component: () => import('@/views/groupWeb/review.vue'),
          },
          {
            path: '/group-web/article/read_record',
            hidden: false,
            name: 'group.read_record',
            meta: {
              title: '浏览记录',
              permission: ['opt:/api/posts/read-record'],
            },
            component: () => import('@/views/groupWeb/readRecord.vue'),
          },
        ],
      },
      // {
      //   path: '/message',
      //   name: 'message',
      //   redirect: '/message/list',
      //   meta: {
      //     title: '消息管理',
      //     icon: xxgl,
      //     permission: ['dashboard']
      //   },
      //   component: RouteView,
      //   children: [{
      //       path: '/message/list',
      //       name: 'message.message_push',
      //       meta: {
      //         title: '消息通知',
      //         permission: ['dashboard']
      //       },
      //       component: () => import('@/views/message/index.vue')
      //     },
      //     {
      //       path: '/message/system/edit',
      //       name: 'systemEdit',
      //       hidden: true,
      //       meta: {
      //         title: '系统-发布消息',
      //         permission: ['dashboard']
      //       },
      //       component: () => import('@/views/message/system-edit.vue')
      //     },
      //     {
      //       path: '/message/application/edit',
      //       name: 'applicationEdit',
      //       hidden: true,
      //       meta: {
      //         title: '应用-发布消息',
      //         permission: ['dashboard']
      //       },
      //       component: () => import('@/views/message/application-edit.vue')
      //     },
      //     {
      //       path: '/location',
      //       name: 'message.location',
      //       meta: {
      //         title: '位置管理',
      //         permission: ['dashboard']
      //       },
      //       component: () => import('@/views/location/index.vue')
      //     },
      //   ]
      // },
      // {
      //   path: '/branchAddress',
      //   name: 'branch_office_address',
      //   hidden: true,
      //   meta: {
      //     title: '分公司地址管理',
      //     icon: fgsdz,
      //     permission: ['opt:/api/branch-office-address/list'],
      //   },
      //   component: () => import('@/views/branchAddress/index.vue'),
      // },
      {
        path: '/companyAddress',
        name: 'company_address',
        hidden: true,
        meta: {
          title: '公司地址管理',
          icon: fgsdz,
          permission: ['opt:/api/branch-office-address-v2/list'],
        },
        component: () => import('@/views/companyAddress/index.vue'),
      },
      {
        path: '/websiteAdmin',
        name: 'website-map',
        hidden: false,
        meta: {
          title: '网站管理',
          icon: linkgl,
          permission: [
            'opt:/api/website-map-detail/list',
            'opt:/api/quick-business-communication/list',
            'opt:/api/die-links/brand-items',
          ],
        },
        redirect: '/websiteAdmin/websiteMap',
        component: RouteView,
        children: [
          {
            path: '/websiteAdmin/cacheManage',
            name: 'websiteAdmin.cacheManage',
            meta: {
              title: '缓存管理',
              permission: ['opt:/api/cache-manage/site-list'],
            },
            component: () => import('@/views/websiteAdmin/cacheManage/index.vue'),
          },
          {
            path: '/websiteAdmin/cacheSite',
            name: 'websiteAdmin.cacheSite',
            hidden: true,
            meta: {
              title: '',
              permission: [],
            },
            component: () => import('@/views/websiteAdmin/cacheManage/cacheSite.vue'),
          },
          {
            path: '/websiteAdmin/websiteMap',
            name: 'websiteAdmin.websiteMap',
            meta: {
              title: '网站地图',
              permission: ['opt:/api/website-map-detail/list'],
            },
            component: () => import('@/views/websiteAdmin/websiteMap/index.vue'),
          },
          {
            path: '/websiteAdmin/distribution',
            name: 'websiteAdmin.distribution',
            meta: {
              title: '快商通',
              permission: ['opt:/api/quick-business-communication/list'],
            },
            component: () => import('@/views/websiteAdmin/distribution/distribution.vue'),
          },
          {
            path: '/websiteAdmin/deadLinks',
            name: 'websiteAdmin.deadLinks',
            meta: {
              title: '死链上传',
              permission: ['opt:/api/die-links/brand-items'],
            },
            component: () => import('@/views/websiteAdmin/deadLinks/index.vue'),
          },
          {
            path: '/deadLinks/lookArticle',
            name: 'deadLinks.lookArticle',
            hidden: true,
            meta: {
              title: '查看详情',
              permission: [],
            },
            component: () => import('@/views/websiteAdmin/deadLinks/lookArticle.vue'),
          },
          {
            path: '/websiteAdmin/lookArticle',
            name: 'websiteAdmin.lookArticle',
            hidden: true,
            meta: {
              title: '查看详情',
              permission: [],
            },
            component: () => import('@/views/websiteAdmin/websiteMap/websiteMap/lookArticle.vue'),
          },
          {
            path: '/websiteAdmin/recommendedKeywords',
            name: 'websiteAdmin.recommendedKeywords',
            meta: {
              title: '推荐关键词',
              permission: ['opt:/api/recommend-keyword/list'],
            },
            component: () => import('@/views/websiteAdmin/recommendedKeywords/index.vue'),
          },
          {
            path: '/websiteAdmin/thesaurus',
            name: 'websiteAdmin.Thesaurus',
            meta: {
              title: '词库管理',
              permission: [],
            },
            component: () => import('@/views/websiteAdmin/thesaurus/index.vue'),
          },
          // {
          //   path: '/websiteAdmin/linkRule',
          //   name: 'websiteAdmin.linkRule',
          //   meta: {
          //     title: '链接规则',
          //     icon: 'slack',
          //     permission: [ 'dashboard' ]
          //   },
          //   component: () => import('@/views/websiteAdmin/linkRule.vue')
          // },
          {
            path: '/websiteAdmin/antireptileSet',
            name: 'antireptileSet',
            meta: {
              title: '反爬设置',
              permission: ['opt:/api/websiteAdmin/antireptile/set'],
            },
            component: () => import('@/views/websiteAdmin/antireptileSet/index.vue'),
          },
          {
            path: '/websiteAdmin/publicInformationSet',
            name: 'publicInformationSet',
            meta: {
              title: '公共信息管理',
              permission: ['opt:/api/websiteAdmin/public/information/set'],
            },
            component: () => import('@/views/websiteAdmin/publicInformationSet/index.vue'),
          },
        ],
      },
      {
        path: '/electrinic-journals',
        name: 'periodical',
        hidden: false,
        meta: {
          title: '电子期刊',
          icon: dzqk,
          permission: ['opt:/api/periodical/list'],
        },
        redirect: '/electrinic-journals/list',
        component: RouteView,
        children: [
          {
            path: '/electrinic-journals/list',
            name: 'periodical.periodical_list',
            meta: {
              title: '期刊列表',
              permission: ['opt:/api/periodical/list'],
            },
            component: () => import('@/views/electrinicJournals/journalList.vue'),
          },
          // {
          //   path: '/electrinic-journals/edit',
          //   name: 'periodical.periodical_list',
          //   hidden: true,
          //   meta: {
          //     title: '期刊设置',
          //     permission: [ ]
          //   },
          //   component: () => import('@/views/electrinicJournals/editJournal/editJournal.vue')
          // }
        ],
      },
      {
        path: '/activities-set',
        name: 'activity',
        redirect: '/activities-set/activity',
        component: RouteView,
        meta: {
          title: '活动管理',
          icon: 'fire',
          permission: [
            'opt:/api/platform-activity/list',
            'opt:/api/platform-prize/list',
            'opt:/api/platform-prize-category/list',
            'opt:/api/platform-activity-category/list',
          ],
        },
        children: [
          {
            path: '/activities-set/activity',
            name: 'activity.activity_list',
            meta: {
              title: '活动列表',
              permission: ['opt:/api/platform-activity/list'],
            },
            component: () => import('@/views/activitiesSet/activity/index.vue'),
          },
          {
            path: '/activities-set/prize-claim/:id',
            hidden: true,
            meta: {
              title: '中奖记录',
              permission: [],
            },
            component: () => import('@/views/activitiesSet/prizeClaim/index.vue'),
          },
          {
            path: '/activities-set/prize',
            name: 'activity.prize_list',
            meta: {
              title: '奖品列表',
              permission: ['opt:/api/platform-prize/list'],
            },
            component: () => import('@/views/activitiesSet/prize/index.vue'),
          },
          {
            path: '/activities-set/prize-type',
            name: 'activity.prize_category_list',
            meta: {
              title: '奖品类型管理',
              permission: ['opt:/api/platform-prize-category/list'],
            },
            component: () => import('@/views/activitiesSet/prizeType/index.vue'),
          },
          {
            path: '/activities-set/type',
            name: 'activity.activity_category_list',
            meta: {
              title: '活动类型管理',
              permission: ['opt:/api/platform-activity-category/list'],
            },
            component: () => import('@/views/activitiesSet/activityType/index.vue'),
          },
        ],
      },
      // {
      //   path: '/message',
      //   name: 'message',
      //   meta: {
      //     title: '消息通知',
      //     icon: 'slack',
      //     permission: [ 'dashboard' ]
      //   },
      //   component: () => import('@/views/message/index.vue')
      // },
      // {
      //   path: '/location',
      //   name: 'location',
      //   meta: {
      //     title: '位置管理',
      //     icon: 'slack',
      //     permission: [ 'dashboard' ]
      //   },
      //   component: () => import('@/views/location/index.vue')
      // }
    ],
  },
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login'),
      },
    ],
  },
  {
    path: '/account',
    component: BasicLayout,
    redirect: '/account/center',
    hidden: true,
    name: 'account',
    meta: {
      title: '个人页',
      icon: 'user',
      keepAlive: true,
      permission: ['user'],
    },
    children: [
      {
        path: '/account/settings',
        name: 'settings',
        component: () => import('@/views/account/settings/Index'),
        // component: () => RouteView,
        meta: {
          title: '个人设置',
          hideHeader: true,
          permission: ['user'],
        },
        redirect: '/account/settings/base',
        hideChildrenInMenu: true,
        children: [
          {
            path: '/account/settings/base',
            name: 'BaseSettings',
            component: () => import('@/views/account/settings/BaseSetting'),
            meta: {
              title: '基本设置',
              hidden: true,
              permission: ['user'],
            },
          },
          {
            path: '/account/settings/security',
            name: 'SecuritySettings',
            component: () => import('@/views/account/settings/Security'),
            meta: {
              title: '安全设置',
              hidden: true,
              keepAlive: true,
              permission: ['user'],
            },
          },
          {
            path: '/account/settings/custom',
            name: 'CustomSettings',
            component: () => import('@/views/account/settings/Custom'),
            meta: {
              title: '个性化设置',
              hidden: true,
              keepAlive: true,
              permission: ['user'],
            },
          },
          {
            path: '/account/settings/binding',
            name: 'BindingSettings',
            component: () => import('@/views/account/settings/Binding'),
            meta: {
              title: '账户绑定',
              hidden: true,
              keepAlive: true,
              permission: ['user'],
            },
          },
          {
            path: '/account/settings/notification',
            name: 'NotificationSettings',
            component: () => import('@/views/account/settings/Notification'),
            meta: {
              title: '新消息通知',
              hidden: true,
              keepAlive: true,
              permission: ['user'],
            },
          },
        ],
      },
    ],
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true,
  },
  {
    path: '/403',
    name: '403',
    hidden: true,
    meta: {
      title: '404',
      permission: ['exception'],
    },
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/403'),
  },
  {
    path: '/404',
    name: '404',
    hidden: true,
    meta: {
      title: '404',
      permission: ['exception'],
    },
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404'),
  },
]
